import { render, staticRenderFns } from "./AssetTable.vue?vue&type=template&id=99da7cde&"
import script from "./AssetTable.vue?vue&type=script&lang=ts&"
export * from "./AssetTable.vue?vue&type=script&lang=ts&"
import style0 from "./AssetTable.vue?vue&type=style&index=0&id=99da7cde&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports